var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { electron } from 'lib-shared-electron';
import { compareSemVer } from 'lib-shared-semver';
/**
 * Compare two versions of releases to see if the version is below the specified
 * version
 *
 * @param desktopAppNoticeCache The version that's being compared to
 */
export function isDesktopAppVersionBelow(version) {
    return __awaiter(this, void 0, void 0, function* () {
        const desktopAppVersion = yield electron.getVersion();
        return compareSemVer(desktopAppVersion, version) === -1;
    });
}
